import React from 'react';
import { ApolloProvider } from '@trello/graphql';
import { useOfflineState } from './useOfflineState';
import { TrelloOnline } from 'app/src/components/TrelloOnline';

export const App = () => {
  const wasEverOffline = useOfflineState();

  if (wasEverOffline) {
    window.location.href = `/offline?returnUrl=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }

  return (
    <ApolloProvider>
      <TrelloOnline />
    </ApolloProvider>
  );
};
